import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "custom-collapse" }

import Controller from './controller.vue';
  import { reactive, inject, computed, watchEffect } from 'vue';
  import { IProps as ProgramCollapseProps } from '@/templates/on-going-program/components/collapse.vue';
  import { FormItem } from '@/types/form';

  export interface IProps {
    props: ProgramCollapseProps,
    modelValue?: boolean;
  }
  export interface IEmits {
    (event: 'update:modelValue', props: boolean): void;
    (event: 'change', props: ProgramCollapseProps): void;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    props: null,
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue", "change"],
  setup(__props: any, { emit: emits }: { emit: ({
    (event: 'update:modelValue', props: boolean): void;
    (event: 'change', props: ProgramCollapseProps): void;
  }), expose: any, slots: any, attrs: any }) {

const componentProps = __props as {
    props: ProgramCollapseProps,
    modelValue?: boolean;
  }

  
  
  const editorMode = inject('editorMode');

  const form = reactive<ProgramCollapseProps>({});
  const formList = computed<FormItem[]>(() => {
    return [
      {
        label: 'Title',
        type: 'input',
        key: 'title',
        required: false,
      }
    ];
  });

  const handleChange = (form: ProgramCollapseProps) => {
    emits('change', form);
  };

  const handleRichTextChange = (content: any) => {
    handleChange({ content });
  };

  watchEffect(() => {
    Object.assign(form, componentProps.props);
  });


return (_ctx: any,_cache: any) => {
  const _component_AppRichText = _resolveComponent("AppRichText")!
  const _component_ProgramCollapse = _resolveComponent("ProgramCollapse")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(editorMode))
      ? (_openBlock(), _createBlock(Controller, {
          key: 0,
          title: "Collapse",
          visible: __props.modelValue,
          "form-list": _unref(formList),
          form: _unref(form),
          "onUpdate:visible": _cache[0] || (_cache[0] = visible => emits('update:modelValue', visible)),
          onChange: handleChange
        }, null, 8, ["visible", "form-list", "form"]))
      : _createCommentVNode("", true),
    _createVNode(_component_ProgramCollapse, _normalizeProps(_guardReactiveProps(__props.props)), {
      default: _withCtx(() => [
        (_unref(editorMode))
          ? (_openBlock(), _createBlock(_component_AppRichText, {
              key: 0,
              content: __props.props.content,
              options: { toolbar: { buttons: ['bold', 'italic', 'underline', 'anchor'] } },
              onChange: handleRichTextChange
            }, null, 8, ["content"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 16)
  ]))
}
}

})